import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, FormattedRelative, FormattedTime } from 'react-intl';
import EventBus from "../../common/EventBus.js";
import GlobalHelper from "../../common/GlobalHelper.jsx";
import EmailModal from "../../common/email/emailmodal.component.jsx";
import SendEmailModal from "../../common/email/sendemail.component.jsx";
import EmailStatusBadge from "../../common/email/status.component.jsx";
import Icon from "../../common/icon/icon.component.jsx";

class AnalyticsQuoteEmails extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            project: this.props.project,
            proposal: this.props.proposal || null,
            contractProposal: this.props.contractProposal || null,
            emails: this.sortEmails(this.props.emails) || null,
            isEditable: this.props.isEditable === true,
            showAllEmails: false,
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            modal: '',
        }
        this.triggerShowAllEmails = this.triggerShowAllEmails.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.openSendEmail = this.openSendEmail.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
        this.sortEmails = this.sortEmails.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            emails: this.sortEmails(nextProps.emails) || null,
            proposal: nextProps.proposal || null,
            contractProposal: nextProps.contractProposal || null,
            isEditable: nextProps.isEditable === true,
        })
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        let proposal = this.state.proposal
        if (templateKey === 'send-contract' && this.state.contractProposal) {
            proposal = this.state.contractProposal
        }

        AppContext.getApiClient()
            .post('/proposals/' + proposal.attributes.hash + '/send-by-email', {
                subject: subject,
                toEmail: toEmail,
                ccEmail: ccEmail,
                content: content,
                buttonLabel: buttonLabel,
                attachments: pdfIncluded ?
                    [
                        {
                            name: proposal.attributes.variables.document.reference.concat(".pdf"),
                            fileLink: proposal.attributes.variables.document.pdfUri,
                            contentType: "application/pdf",
                        }
                    ] : [],
                fromEmail: fromEmail,
                bccEmail: bccEmail,
                fromName: fromName,
            })
            .then(res => {
                if (res.id) {
                    this.state.onChange(res)
                    EventBus.dispatch(EventBus.TopicQuoteSent, {
                        proposal: res,
                    })
                }
            })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    openSendEmail(event, proposalType) {
        event.preventDefault()
        let proposal = this.state.proposal
        if (proposalType === 'contract' && this.state.contractProposal) {
            proposal = this.state.contractProposal
        }
        // Formatting the name to prevent an edge case with a single email and a name containing semi colons or commas
        let { name, email } = proposal.attributes.variables.customer;
        email = email.includes(",") || email.includes(';') ? email : name + " <" + email + ">"

        proposalType = proposalType || proposal.attributes.variables.document.type
        const template = GlobalHelper.getEmailTemplateByProposalType(proposalType)
        this.setState({
            modal: <SendEmailModal
                templateId={this.props.templateId}
                onSubmit={this.sendProposal}
                onClose={this.handleCloseModal}
                locationId={proposal.attributes.variables.quote.locationId}
                templateKey={template}
                proposalType={proposalType}
                lastEmailSubject={proposal.attributes.lastEmailSubject}
                lastEmailContent={proposal.attributes.lastEmailContent}
                toEmail={email}
                fromName={proposal.attributes.variables.seller.name}
            />
        })
    }

    openEmail(emailId) {
        return function (event) {
            event.preventDefault()
            this.setState({
                modal: <EmailModal
                    onClose={this.handleCloseModal}
                    emailId={emailId}
                />
            })
        }.bind(this)

    }

    getEmailTypeIcon(email) {
        switch (email.attributes.proposalType) {
            case 'quote': return 'file-alt'
            case 'contract':
            default: return 'file-signature'
        }
    }

    sortEmails(array) {
        if (array.length > 0) {
            array.sort((emailA, emailB) => {
                if (emailA.attributes.createdAt > emailB.attributes.createdAt) {
                    return -1;
                }
                if (emailA.attributes.createdAt < emailB.attributes.createdAt) {
                    return 1;
                }
                return 0;
            })
        }
        return array
    }


    renderEmail(e, className) {
        return <div key={e.id} className={'w-100 d-flex bg-light p-2 ' + className}>
            <div className={'min-width-zero'}>
                <h5 className={'m-0 border-0 pb-0'}>
                    <span onClick={this.openEmail(e.id)} >
                        <Icon
                            value={this.getEmailTypeIcon(e)}
                            style={{ cursor: 'pointer' }}
                            className={'mr-2 text-primary'} />
                    </span>
                    {e.attributes.subject}
                </h5>
                <p className={'m-0 text-secondary text-truncate'}>
                    <strong className={'mr-1'}>
                        <FormattedMessage
                            id="quote.analytics.email.to_label"
                            defaultMessage="To:"
                        />
                    </strong>
                    {e.attributes.toEmail}
                </p>
                {e.attributes.ccEmail ? <p className={'m-0 text-secondary text-truncate'}>
                    <strong className={'mr-1'}>
                        <FormattedMessage
                            id="quote.analytics.email.cc_label"
                            defaultMessage="Cc:"
                        />
                    </strong>
                    {e.attributes.ccEmail}
                </p> : ''}
                <p className={'m-0 text-secondary'}>
                    <strong className={'mr-1'}>
                        <FormattedMessage
                            id="quote.analytics.email.last_activity_label"
                            defaultMessage="Last activity:"
                        />
                    </strong>
                    <FormattedRelative value={new Date(e.attributes.lastUpdatedAt)} />
                </p>

                {
                    e.attributes.events.map(event => {
                        if (event.attributes.eventType !== "error") {
                            return ''
                        }
                        return <div className="ml-2 mb-2 mt-2 text-danger">{event.attributes.message}</div>
                    })
                }

            </div>
            <div className={'ml-auto'}>
                {e.attributes.sentAt ? <p className={'m-0 text-secondary text-right'}>
                    <small>
                        <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={new Date(e.attributes.sentAt)}
                        />
                        &nbsp;
                        <FormattedTime value={new Date(e.attributes.sentAt)} />
                    </small>
                </p> : ''}
                <div className={'m-0 w-100 text-right'}>
                    <EmailStatusBadge
                        status={e.attributes.status}
                        events={e.attributes.events}
                        errorMessage={e.attributes.errorMessage}
                    />
                </div>
                <p className={'m-0 text-right mt-1'}>
                    <button className={'btn-sm btn btn-outline-primary'} onClick={this.openEmail(e.id)}>
                        <Icon value={'eye'} className={'mr-1'} />
                        <FormattedMessage
                            id="quote.analytics.email.preview_btn"
                            defaultMessage="Preview"
                        />
                    </button>
                </p>
            </div>
        </div>
    }

    triggerShowAllEmails(e) {
        e.preventDefault()
        this.setState({
            showAllEmails: !this.state.showAllEmails,
        })
    }

    render() {
        return <div className={'row'}>
            {this.state.modal}
            <div className={'col-12'}>
                {this.state.emails.length === 0 && <div className={'w-100 text-secondary text-center py-2 mb-2 strong'} style={{ border: '5px dashed #dee2e6' }}>
                    <em>
                        <FormattedMessage
                            id="quote.analytics.email.no_email_sent_yet"
                            defaultMessage="No email has been sent yet..."
                        />
                    </em>
                </div>}
                {!this.state.showAllEmails && this.state.emails.length > 0 && this.renderEmail(this.state.emails[0], 'mb-0')}
                {!this.state.showAllEmails && this.state.emails.length > 1 && <div className={'w-100 text-center pt-1'} >
                    <small>
                        <a href={'#'} onClick={this.triggerShowAllEmails}>
                            <Icon value={'arrows-alt-v'} />
                            <FormattedMessage
                                id="quote.analytics.email.show_all_emails"
                                defaultMessage="Show {count} previous email(s)"
                                values={{
                                    count: this.state.emails.length - 1
                                }}
                            />
                        </a>
                    </small>
                </div>}
                {this.state.showAllEmails && this.state.emails.map(e => {
                    return this.renderEmail(e, 'mb-2')
                })}
                {this.state.showAllEmails && this.state.emails.length > 1 && <div className={'w-100 text-center pt-1'} >
                    <small>
                        <a href={'#'} onClick={this.triggerShowAllEmails}>
                            <Icon value={'arrows-alt-v'} />
                            <FormattedMessage
                                id="quote.analytics.email.hide_all_emails"
                                defaultMessage="Hide emails"
                            />
                        </a>
                    </small>
                </div>}
                {this.state.isEditable ? <div className={'w-100 mb-2 mt-2'}>
                    <div className="btn-group dropup">
                        <button className={'btn btn-primary'} onClick={this.openSendEmail}>
                            <Icon value={'pen-alt'} className={'mr-1'} />
                            <FormattedMessage
                                id="quote.analytics.email.write_new_email_btn"
                                defaultMessage="Write an email"
                            />
                        </button>
                        {this.state.contractProposal &&
                            [<button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            </button>,
                            <div className="dropdown-menu">
                                <a className="dropdown-item" href="#" onClick={(e) => this.openSendEmail(e, 'contract')}>
                                    <Icon value={'pen-alt'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="quote.analytics.email.write_new_email_contract_btn"
                                        defaultMessage="Write an email (contract)"
                                    />
                                </a>
                            </div>]
                        }
                    </div>

                </div> : ''}
            </div>
        </div>
    }

}

export default AnalyticsQuoteEmails





// WEBPACK FOOTER //
// ./src/quote/analytics/quoteemails.component.jsx